import Vue from 'vue';
import Vuex from 'vuex';

// Importing default/additional & responseData parameters --> input & merging them with Vuex Store
import defaultInputParameters from './modules/defaultInputParameters';
import additionalInputParameters from './modules/additionalInputParameters';
import responseDataParameters from './modules/responseDataParameters';
import validationParameters from './modules/validationParameters';
import labels from './modules/labels';
import flags from './modules/flags';
import languages from './modules/languages';
import cropTypes from './modules/cropTypes';

Vue.use(Vuex);

export default new Vuex.Store({

  // Defined & merged values
  state: {
  },

  // Defined & merged getters
  getters: {
  },

  // Defined & merged mutations/setters
  mutations: {
  },

  // Calling action methods in components
  // Enabling mutations to run asynchronously
  // Defined & merged actions
  actions: {
  },

  // Merging input & default parameters
  modules: {
    defaultInputParameters,
    additionalInputParameters,
    responseDataParameters,
    validationParameters,
    labels,
    flags,
    languages,
    cropTypes
  }
});
